import React from "react";
import { MdLightbulbOutline, MdLightbulb } from "react-icons/md";

interface MachineSwitchProps {
  checked: boolean;
  labelOn: string;
  labelOff: string;
  colorOn?: string;
  colorOff?: string;
}


const MachineSwitch: React.FC<MachineSwitchProps> = ({ checked, labelOn, labelOff, colorOn = '#4caf50', colorOff = '#888' }) => (
  <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
    {checked ? (
      <MdLightbulb size={24} color={"#FFD600"} style={{ verticalAlign: 'middle' }} />
    ) : (
      <MdLightbulbOutline size={24} color={colorOff} style={{ verticalAlign: 'middle' }} />
    )}
    <span style={{ color: checked ? colorOn : colorOff, fontWeight: 600 }}>
      {checked ? labelOn : labelOff}
    </span>
  </span>
);

export default MachineSwitch;
